import Vue from 'vue'
import VueRouter from 'vue-router'
import { getToken } from '../utils/request'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: () => import('../layout/MainLayout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('../views/Dashboard.vue'), meta: { title: '概览' } },
      { path: 'users', name: 'Users', component: () => import('../views/Users.vue'), meta: { title: '用户' } },
      { path: 'products', name: 'Products', component: () => import('../views/Products.vue'), meta: { title: '产品' } },
      { path: 'daily-rates', name: 'DailyRates', component: () => import('../views/DailyRates.vue'), meta: { title: '每日利率' } },
      { path: 'holdings', name: 'Holdings', component: () => import('../views/Holdings.vue'), meta: { title: '持仓' } },
      { path: 'invests', name: 'Invests', component: () => import('../views/Invests.vue'), meta: { title: '申购' } },
      { path: 'wallet-approves', name: 'WalletApproves', component: () => import('../views/WalletApproves.vue'), meta: { title: '钱包授权' } },
      { path: 'redeems', name: 'Redeems', component: () => import('../views/Redeems.vue'), meta: { title: '赎回' } },
      { path: 'recharges', name: 'Recharges', component: () => import('../views/Recharges.vue'), meta: { title: '充值' } },
      { path: 'withdraws', name: 'Withdraws', component: () => import('../views/Withdraws.vue'), meta: { title: '提现' } },
      { path: 'invites', name: 'Invites', component: () => import('../views/Invites.vue'), meta: { title: '邀请' } },
      { path: 'live', name: 'Live', component: () => import('../views/Live.vue'), meta: { title: '实时动态' } },
      { path: 'cms', name: 'Cms', component: () => import('../views/Cms.vue'), meta: { title: '协议文案' } },
      { path: 'configs', name: 'Configs', component: () => import('../views/Configs.vue'), meta: { title: '系统配置' } },
      { path: 'admins', name: 'Admins', component: () => import('../views/Admins.vue'), meta: { title: '管理员' } },
    ],
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    if (to.name === 'Login' && getToken()) {
      next({ name: 'Dashboard' })
      return
    }
    next()
    return
  }
  if (!getToken()) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
